<template>
  <div v-if="lot.currency" class="ta-lot-estimates">
    <label v-if="label" class="ta-lot-estimates-label">{{ label }}</label>
    <span class="ta-lot-estimates-amount">
      {{ lot.low | asCurrency(lot.currency.code) }} - {{ lot.high | asCurrency(lot.currency.code) }}
    </span>
  </div>
</template>

<script>
export default {
  name: "LotStartPrice",
  props: {
    lot: {
      required: true,
      type: Object
    },
    label: {
      required: false,
      type: [String, Boolean],
      default() {
        return this.$t('Estimate')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../../bootstrap/import";

.ta-lot-estimates {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .ta-lot-estimates-amount {
    color: $primary;
    font-weight: bold;
    font-size: $font-size-base;
  }
}
</style>
